import { render } from "./SourceBox.vue?vue&type=template&id=30b05c58&scoped=true"
import script from "./SourceBox.vue?vue&type=script&lang=js"
export * from "./SourceBox.vue?vue&type=script&lang=js"

import "./SourceBox.vue?vue&type=style&index=0&id=30b05c58&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b05c58"]])

export default __exports__